<template>
  <div class="grid grid-cols-1 mt-8 gap-y-4">
    <line-chart
      title="% Cajas rechazadas por proveedor (Semanal)"
      :categories="this.weeks"
      :series="percentage_rejected_series"
    ></line-chart>

    <line-chart
      title="Cajas Rechazadas por cada 100 exportadas (Semanal)"
      :categories="this.weeks"
      :series="percentage_rejected_by_exported_series"
    ></line-chart>

    <div class="panel">
      <div class="panel-header">
        <div class="flex justify-between items-center">
          <h3 class="panel-header-title">
            Distribución de defectos por proveedor
          </h3>
          <div class="w-80">
            <select-form
              :options="providers"
              v-model="selected_provider"
              label="name"
            />
          </div>
        </div>
      </div>
      <div class="panel-body">
        <apexchart
          ref="chart"
          height="400"
          width="100%"
          :options="chartOptions2"
          :series="processed_defect_series"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";

import VueApexCharts from "vue3-apexcharts";
import LineChart from "@/components/views/layout/quality_reports/LineChart.vue";
export default {
  name: "QualityReportsContainerProviderShowProcessGraphics",
  components: {
    apexchart: VueApexCharts,
    LineChart
  },
  data() {
    return {
      selected_provider: null
    };
  },
  props: {
    rejected_series: {
      type: Array,
      required: true
    },
    defect_series: {
      type: Array,
      required: true
    },
    defects: {
      type: Array,
      required: true
    },
    weeks: {
      type: Array,
      required: true
    },
    providers: {
      type: Array,
      required: true,
      default: () => [{ id: null, name: "Todos" }]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.providers.forEach((s, index) => {
        if (index !== 0) {
          ApexCharts.exec("line", "hideSeries", s.name);
        }
      });
    });
  },

  methods: {},

  computed: {
    chartOptions2: function () {
      return {
        chart: {
          type: "bar",
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "45%",
            borderRadius: 5,
            borderRadiusApplication: "end"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: this.defect_series.map(serie => serie.name)
        },
        yaxis: {
          title: {
            text: "# defectos"
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "# " + val + " defectos";
            }
          }
        },
        colors: ["#ef4444"]
      };
    },
    percentage_rejected_series: function () {
      let series = [...this.rejected_series];
      return series.map(item => {
        return {
          name: item.name,
          color: item.color,
          data: item.percentages.slice(0, -1)
        };
      });
    },

    percentage_rejected_by_exported_series: function () {
      let series = [...this.rejected_series];
      return series.map(item => {
        return {
          name: item.name,
          color: item.color,
          data: item.percentage_rejected_exported.slice(0, -1)
        };
      });
    },

    processed_defect_series: function () {
      const providerIndex = this.providers
        .map(prov => prov.id)
        .indexOf(this.selected_provider);
      return [
        {
          name: this.defects[providerIndex]?.name ?? "Todos",
          data: this.defect_series.map(serie => serie.data[providerIndex])
        }
      ];
    }
  }
};
</script>
